import history from '../../../services/history';

const logout = () => {
  localStorage.clear();
  sessionStorage.clear();

  const isDev = window.location.hostname === 'localhost';

  if (isDev) {
    history.push('/login');
  } else {
    // Abre logout do Google em uma aba oculta e redireciona para /login
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = 'https://accounts.google.com/logout';
    document.body.appendChild(iframe);

    setTimeout(() => {
      document.body.removeChild(iframe);
      window.location.href = `${window.location.origin}/login`;
    }, 2000);
  }
};

export default logout;
// const LogoutButton = () => {
//   localStorage.clear();
//   sessionStorage.clear();
//   window.location.href = `https://accounts.google.com/logout`;
// };

// export default LogoutButton;
